import * as React from "react"

export default class Badge extends React.Component<Props> {
	render() {
		return <div className="badge" title={this.props.title}>
			{this.props.value}
		</div>
	}
}

export interface Props {
	title?: string;
	value: number;
}



// WEBPACK FOOTER //
// ./src/component/badge/index.tsx